export default function CatalogDetailCompactChips({
  values = []
}) {
  if (!Array.isArray(values) || values.length === 0) {
    return null;
  }

  return (
    <div className="catalog-detail__chips catalog-detail__chips--compact">
      {values.map((value) => (
        <span key={value}>{value}</span>
      ))}
    </div>
  );
}
